import React from 'react';
import { Avatar } from 'design-system/avatar';
import { CIRCLE_BORDER_SIZE, CIRCLE_SIZE } from 'design-system/LogoBankAccount';
import useColors from 'hooks/useColors';
const GroupAvatar = ({ url, name, style, size, borderWidth = CIRCLE_BORDER_SIZE, }) => {
    const colors = useColors();
    return (<Avatar imageUrl={url} name={name} size={size ?? CIRCLE_SIZE} borderWidth={borderWidth} color={colors.background.brandLight} fontColor={colors.text.textOnBrand} style={style} medium/>);
};
export default GroupAvatar;
